<template>
  <div class="row justify-between no-wrap">
    <RightArrowRed/>
    <q-form
      @submit="onSubmit"
      class="column items-center">
      <img src="/img/Logo_Original_Blanc_100px.png" class="q-mb-md"/>
      <q-input 
        dark autofocus v-model="code_acces" label-color="grey-3" dense color="grey-3" class="q-mb-lg" label-slot input-class="text-center">
        <template v-slot:label>
          <div class="text-center">
            N° SESSION BAR
          </div>
        </template>
      </q-input>
      <q-btn id="access_session" outline label="Accéder à la session" type="submit" color="grey-3" size="sm" class="q-mt-lg q-mb-xl"/>
    </q-form>
    <LeftArrowGreen/>
  </div>
</template>
<script>
import { getSeanceByCodeAcces } from '~/services/seances';
import RightArrowRed from '~/components/right-arrow-red';
import LeftArrowGreen from '~/components/left-arrow-green';
import posthog from 'posthog-js'

export default {
  name: 'WelcomeInput',
  components: {
    RightArrowRed,
    LeftArrowGreen
  },
  data() {
    return {
      code_acces: '',
    };
  },
  methods: {
    async onSubmit() {
      const resp = await getSeanceByCodeAcces(this.code_acces)
      if (resp.status === 200 ) {
        posthog.capture('access_session', {
          code_acces: this.code_acces,
          seance_id: resp.data.id,
        });
        this.$router.push({name:'mobileDrinksList', params: {idSeance: resp.data.id}});
      }
    },
  },
};
</script>
<style lang="scss">
#access_session {
  width: 70%;
}
</style>